import React, { PureComponent } from 'react';
class Iva extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { motivoAjusteDataFiltrado, ajusteEdicion, importeSinIva, motivoAjusteEdicion } = this.props.ingresoAjuste;
        let tasa;
        if (ajusteEdicion && ajusteEdicion.Codigo == motivoAjusteDataFiltrado.Codigo) {
            tasa = motivoAjusteEdicion[0].PermiteIva ? motivoAjusteEdicion[0].MontoIva : + "0";
        } else tasa = motivoAjusteDataFiltrado && motivoAjusteDataFiltrado.PermiteIva ? +  motivoAjusteDataFiltrado.MontoIva : + "0";

        let importeAMostrar = importeSinIva;
        let importeIva = "$ ";
        if(importeSinIva == "" || isNaN(importeSinIva) || importeSinIva == undefined)
        { importeIva = "$ "}
        else
        { 
            importeSinIva < 0 ? (importeAMostrar = importeSinIva * -1) : importeAMostrar = importeSinIva;
            importeIva = "$ " + parseFloat(importeAMostrar / 100 * tasa).toFixed(2);
        }

        if (motivoAjusteDataFiltrado && motivoAjusteDataFiltrado.TipoMovimiento) {
            importeSinIva < 0 ? (importeAMostrar = importeSinIva * -1) : importeAMostrar = importeSinIva;
            importeIva = "$ " + parseFloat(importeAMostrar / 100 * tasa).toFixed(2);
        }

        return (
            <div className="row top-separator-xs"> 
                    <label className="label-primary contenedorLabelImporteTotal" >IVA *</label>
                    <label className="contenedorMontoImporteTotal">{importeIva}</label>
            </div>
        )
    }
}

export default Iva;